import { Suspense } from "react";
import { useDocumentTitle } from "@/i18n";
import { LoginView } from "./_components";

const LoginPage = () => {
  useDocumentTitle("login.page");

  return (
    <Suspense fallback={null}>
      <LoginView />
    </Suspense>
  );
};

export default LoginPage;
